import { default as SetupAccordion } from './SetupAccordion';

export default SetupAccordion;
export * from './SetupAccordionProps';
